<template>
  <b-modal class="modal-xl" size="xl" id="documentReceipt" ref="documentReceipt-modal" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" @show="getReceiptData()" @hide="closeReceipt()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fas', 'money-check']" size="1x" class="mr-2"/>{{ t('paymentReceiptText', 'paymentReceiptText') }} <small v-if="documents">{{ documents.payment_reference }}</small></h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="closeReceipt()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default" slot-scope="{ close }">
      <div class="row" id="receiptDiv" v-if="!isLoading">
        <table v-if="documents" class="table b-table table-striped table-hover table-bordered">
          <thead class="">
            <tr class="brand-color">
              <th>{{ t('documentReference', 'documentReference') }}</th>
              <th>{{ t('paymentDateText', 'paymentDateText') }}</th>
              <th>{{ t('paymentMethodText', 'paymentMethodText') }}</th>
              <th>{{ t('paymentRefrenceText', 'paymentRefrenceText') }}</th>
              <th>{{ t('totalValueLabel', 'totalValueLabel') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="doc in documents.receipt">
              <td>
                <router-link class="hide-color" :to="{ name: 'view_document', params: { id: doc.id, type: 'online' }}" target="_blank">
                  {{ doc.reference }}
                </router-link>
              </td>
              <td>{{ doc.transaction_datetime | humanReadable }}</td>
              <td>{{ doc.payment_method_name }}</td>
              <td>{{ doc.unique_reference }}</td>
              <td>{{ doc.currency }} {{ doc.doc_paid_amount }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td class="text-right" colspan="4">
                {{ t('totalPaidText', 'totalPaidText') }}
              </td>
              <td>
                {{ documents.currency }} {{ documents.totalAmount }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div v-else>
        <div class="vld-parent spinner-row text-center">
          <loading :active.sync="isLoading"
          :can-cancel="false"
          :color="'#047bf8'"
          :loader="'dots'"
          :is-full-page="false"></loading>
        </div>
      </div>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel, close }">
      <div>
        <button class="btn btn-primary mr-2" v-if="documents" @click="printReceipt()"><i class="os-icon os-icon-printer mr-2"></i>{{ t('printText', 'printText') }}</button>
        <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary mr-2" type="button" @click="closeReceipt()">
          <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('closeText', 'closeText') }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Loading from 'vue-loading-overlay'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'ModalDocumentReceipt',
  props: ['receiptDocId'],
  data () {
    return {
      isLoading: false,
      documents: null
    }
  },
  computed: {
    ...mapGetters(['getResponseInfo']),
  },
  components: {
    Loading
  },
  methods: {
    closeReceipt() {
      this.$parent.closeReceipt()
    },

    async getReceiptData() {
      await new Promise(r => setTimeout(r, 200))
      if(this.$props.receiptDocId) {
        this.isLoading = true
        this.$store.dispatch('onlinePaymentStore/getReceiptData', this.$props.receiptDocId).then(response => {
          this.isLoading = false
          this.documents = response
        })
      }
    },
    printReceipt() {
      var mywindow = window.open('', 'PRINT', 'height=400,width=600');

      //mywindow.document.write('<html><head><title>' + 'Receipt Total'  + '</title>');
      //mywindow.document.write('</head><body >');
      //mywindow.document.write('<h1>' + 'Receipt' + '</h1>');
      mywindow.document.write(document.getElementById('receiptDiv').innerHTML);
      //mywindow.document.write('</body></html>');

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      mywindow.close();
    }
  },
  created() {

  },
  filters: {
      humanReadable: function(date) {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    },
  }
}
</script>

<style>
.brand-color > th {
  background-color: #047bf8 !important;
  color: white !important;
}

@media (min-width: 992px)
{
  .modal-lg, .modal-xl {
    max-width: 800px;
  }
}

@media (min-width: 1200px)
{
  .modal-xl {
    max-width: 1140px;
  }
}

</style>
